import { IonCol, IonGrid, IonIcon, IonRow, IonText } from "@ionic/react";
import { setNavigation } from "../../../actions/App/action";
import { EMPTY_MYLOADS_BUCKET, MY_LOAD } from "../../../utils/constants";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ITile } from "./myloads.schema";
import "./myloads.scss";
import { ToolTip } from "../../../components/ToolTip/ToolTip";
import { IONICWrapper } from "../../../utils/common";
import { loadCountFormatter } from "../../../utils/MyLoads.util";

const MyloadTiles = (props: any) => {
  const EmptyMyLoadsBucket = IONICWrapper.details.keys && IONICWrapper.details.keys.configuration && IONICWrapper.details.keys.configuration.emptyMyLoadsBucket || EMPTY_MYLOADS_BUCKET;
  const dispatch = useDispatch();
  const  [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const {
    tiles,
    count,
    history,
    history: {
      location: { pathname },
    },
  } = props;
  const handleClick = (path: string) => {
    if(props?.location?.state?.isGlobalSearch) {
      props.location.state = null
    }
    const __nav: {[key: string]: string } = {};
    __nav[MY_LOAD] = path;
    dispatch(setNavigation(__nav));
    history.push(path);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <IonGrid className="sni-myloads-tile-wrapper">
      <IonRow className="tileStyle">
        {tiles &&
          tiles.map((tile: ITile, index: number) => (
            <IonCol
              key={`myloadTile_${index}`}
              size={(tiles.length && tiles.length===6)  ? "2" : tiles.length === 4 ? "3" :"2.4"}
              className={`tile-wrapper ${((pathname || "").toLocaleLowerCase() ===
                (tile.myLoadRouting || "").toLocaleLowerCase())
                ? count[tile.count] ? "active" : "deactive"
                : count[tile.count] ? "" : "deactive"
                }`}
              onClick={() => (count[tile.count]) ? handleClick(tile.myLoadRouting) : setSelectedIndex(index)}
            >
              <div className={`${count[tile.count] ? "" : "deactive-icons"}`}>
              <div className="icon-wrapper">
                <IonIcon
                  className={`icon ${tile.class}`}
                  src={`${tile.cardImg}`}
                ></IonIcon>
                <IonText className="loads-count">
                  {loadCountFormatter(count[tile.count])}
                </IonText>
              </div>
              <IonText className="label">{tile.title}</IonText>
              </div>
              {(selectedIndex === index && count[tile.count] === 0) && <ToolTip message={EmptyMyLoadsBucket} isActive={selectedIndex === index} clearIndex={()=>setSelectedIndex(null)}/>}
            </IonCol>
          ))}
      </IonRow>
    </IonGrid>
  );
};

export default React.memo(MyloadTiles);
